var _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPurchaseAsteroid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 64 64"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "28.06 43.89 15.34 10.28 12.08 10.28 24.79 43.89 28.06 43.89"
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  points: "48.64 49.75 40.23 49.75 36.79 46.26 18.14 46.26 9.5 55.39 13.82 55.39 45.78 55.39 54.28 55.39 48.64 49.75"
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  points: "46.76 15.3 38.36 15.3 40.67 21.35 38.58 21.35 34.76 11.34 18.69 11.34 24.31 26.06 32.95 26.06 34.46 30.02 52.38 30.02 46.76 15.3"
})));
export default SvgPurchaseAsteroid;